/*
    Copyright 2022 Dynatrace LLC

    Licensed under the Apache License, Version 2.0 (the "License");
    you may not use this file except in compliance with the License.
    You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

    Unless required by applicable law or agreed to in writing, software
    distributed under the License is distributed on an "AS IS" BASIS,
    WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    See the License for the specific language governing permissions and
    limitations under the License.
*/

import { Context, createContextKey } from "@opentelemetry/api";

const cXDtcContextKey = createContextKey("Dynatrace x-dtc header");
const cServerIdContextKey = createContextKey("Dynatrace x-dtc server ID");
const cMobileTagContextKey = createContextKey("Dynatrace mobile tag");

export function setXDtc(context: Context, xDtc: string): Context {
	return context.setValue(cXDtcContextKey, xDtc);
}

export function getXDtc(context: Context): string | undefined {
	const xDtc = context.getValue(cXDtcContextKey);
	return typeof(xDtc) === "string" ? xDtc : undefined;
}

export function setServerId(context: Context, serverId: number): Context {
	return context.setValue(cServerIdContextKey, serverId);
}

export function getServerId(context: Context): number | undefined {
	const serverId = context.getValue(cServerIdContextKey);
	return typeof(serverId) === "number" ? serverId : undefined;
}

export function setMobileTag(context: Context, mt: string): Context {
	return context.setValue(cMobileTagContextKey, mt);
}

export function getMobileTag(context: Context): string | undefined {
	const mt = context.getValue(cMobileTagContextKey);
	return typeof(mt) === "string" ? mt : undefined;
}
